import React, { Component } from 'react'
import EntityList from './../../components/entityList';

class SuspensionTypes extends Component {
  render() {
    return (
      <EntityList apiRoute='api/suspensiontypes' title="Remorque - Types de suspension" editTitle="Type de suspension" displayColumns={[
        {Description: 'Description', Column: 'Description'},
        {Description: 'Inactif', Column: 'Inactive', sortable: false, format: {type: 'boolean'}}
      ]}/>
    )
  }
}

export default SuspensionTypes;


/** WEBPACK FOOTER **
 ** ./src/app/routes/trailers/suspensionTypes.js
 **/